export class UnsupportedTimeZoneError extends Error {
  constructor(message: string) {
    super(message)
    Object.setPrototypeOf(this, UnsupportedTimeZoneError.prototype)
  }
}
